import { Link } from "react-router-dom"

export const NotFoundPage = () => {
    return (
        <div className="w-full flex-1 font-manrope flex flex-col justify-center items-center">
            <div className="text-[180px] leading-[180px] font-bold text-color-primary">
                404
            </div>
            <div className="text-[24px] mb-8 leading-[24px] text-color-base">
                страница не найдена
            </div>
            <div className="text-center text-base text-color-base">
                страница, на которую вы пытаетесь <br />
                попасть, не существует или была удалена. <br />
                Перейти на <Link to='/' className="hover:underline cursor-pointer text-color-primary">Главную страницу</Link>
            </div>
        </div>
    )
}